'use client';
import { useRef } from 'react';
import { Provider } from 'react-redux';

import { StorageScopeInitializer } from '~features/storage';
import type { AppStore } from '~store/index';
import { createStore } from '~store/index';

export const StoresLayout = ({ children }: React.PropsWithChildren) => {
	const storeRef = useRef<AppStore>(null);
	if (!storeRef.current) {
		storeRef.current = createStore();
	}

	return (
		<>
			<StorageScopeInitializer store={storeRef.current} />
			<Provider store={storeRef.current}>{children}</Provider>
		</>
	);
};
